import type { PositionValue } from '@elfsight/configurator-contracts';
import type { BuilderContentAlignment } from '../Builder';

type ContentAlignment = {
  contentAlignment: 'start' | 'center' | 'end';
  blockAlignment: 'start' | 'center' | 'end';
};

export function getAlignmentBlock(
  alignmentElement: 'block' | 'content',
  contentAlignmentValue: PositionValue
): BuilderContentAlignment {
  const alignmentProps = contentAlignmentProps[contentAlignmentValue];

  const alignmentKey: keyof ContentAlignment =
    alignmentElement === 'content' ? 'contentAlignment' : 'blockAlignment';

  return alignmentProps[alignmentKey] === 'center'
    ? 'center'
    : `flex-${alignmentProps[alignmentKey]}`;
}

const contentAlignmentProps: Record<PositionValue, ContentAlignment> = {
  'top-left': {
    contentAlignment: 'start',
    blockAlignment: 'start'
  },
  top: {
    contentAlignment: 'start',
    blockAlignment: 'center'
  },
  'top-right': {
    contentAlignment: 'start',
    blockAlignment: 'end'
  },
  left: {
    contentAlignment: 'center',
    blockAlignment: 'start'
  },
  center: {
    contentAlignment: 'center',
    blockAlignment: 'center'
  },
  right: {
    contentAlignment: 'center',
    blockAlignment: 'end'
  },
  'bottom-left': {
    contentAlignment: 'end',
    blockAlignment: 'start'
  },
  bottom: {
    contentAlignment: 'end',
    blockAlignment: 'center'
  },
  'bottom-right': {
    contentAlignment: 'end',
    blockAlignment: 'end'
  }
};
